import ActionsPopover from "@/components/ActionsPopOver/ActionsPopOver";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import {
  EcoInventDatasetTable,
  ecoInventDatasetTableColumns,
} from "@/components/ImpactReferenceSelector/EcoInventDatasetsTable";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import useTableStateUrl from "@/components/Table/hooks/useTableStateUrl";
import { Column } from "@/components/Table/Table";
import useAnalytics from "@/hooks/useAnalytics";
import { EcoInventDataset, useEcoInventDatasets } from "@/hooks/useEcoInventDatasets";
import { MoreOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export default function EcoInventReferences() {
  const navigate = useNavigate();
  const analytics = useAnalytics();

  analytics.track("EcoInvent References Overview Viewed");

  const columns: Column<EcoInventDataset>[] = [
    ...ecoInventDatasetTableColumns,
    {
      key: "actions",
      label: "Actions",
      minWidth: "80px",
      maxWidth: "80px",
      noLink: true,
      renderer: (reference) => (
        <>
          <ActionsPopover
            actions={
              <>
                <ActionsPopOverItem
                  onClick={() => {
                    navigate(`/impact_references/custom/create/${reference.id}`);
                  }}
                  icon={<PlusOutlined />}
                >
                  Use for new custom impact reference
                </ActionsPopOverItem>
              </>
            }
          >
            <MoreOutlined />
          </ActionsPopover>
        </>
      ),
    },
  ];

  const { pagination, filter, search, sort, onSearchFilterSortPaginate } = useTableStateUrl({
    columns,
    defaultPagination: { page: 1, pageSize: 20 },
    defaultSort: { key: "reference_product_name", order: "ascend" },
  });

  const { data, isLoading, isFetching } = useEcoInventDatasets({
    pagination,
    filter,
    search,
    sort,
  });

  return (
    <div>
      <PageHeader
        title="EcoInvent references"
        description="Use impact references from the most widely used life cycle inventory database globally. Access high-quality, transparent impact data to support your product footprint calculations."
      />
      <div>
        <EcoInventDatasetTable
          columns={columns}
          totalRows={data?.total_count}
          onSearchFilterSortPaginate={onSearchFilterSortPaginate}
          pagination={pagination}
          data={data?.datasets}
          filter={filter}
          search={search}
          sort={sort}
          loading={isLoading || isFetching}
        />
      </div>
    </div>
  );
}
